{
    "RecordingList_Column_Description": "Descrizione",
    "RecordingList_Column_Type": "Tipo",
    "RecordingList_Column_TelSys": "Server di telefonia",
    "RecordingList_Column_Partition": "Partizione",
    "RecordingList_Scope_All": "Tutto",
    "RecordingList_Scope_ServiceWide": "Ampia gamma di servizi",
    "RecordingList_Scope_SystemWide": "a livello di sistema",
    "RecordingList_Scope_Detached": "Distaccato",
    "RecordingList_Type_All": "Tutto",
    "RecordingList_Type_Dubber": "Doppiatore",
    "RecordingList_Scope_Label": "Ambito di applicazione",
    "RecordingList_Type_Label": "Tipo",
    "NAME": "Elenco registrazioniLingua"
}